import React from 'react';
import { useIntl } from 'react-intl';
import { withRouter } from 'react-router';

import { Button } from '@xsolla/ui-core';

import LoginProductLogotype from '../../../assets/login_product_logotype.svg';
import StartPageLoginDemo from '../../../assets/widget-preview-image/start_page_login_demo.svg';
import { PROJECT_LINKS } from '../../../constants';
import { useConfig } from '../../../contexts/config';
import { usePaths } from '../../../routes/routesHelper';
import { StyledLink } from '../../ui';
import {
  AnnotationSpan,
  AnnotationWrapper,
  ClockIcon,
  DemoLoginWrapper,
  GuideIcon,
  GuideLink,
  PlusIcon,
  WelcomeBlockWrapper,
  WelcomeDescription,
  WelcomeTitle,
  Wrapper
} from './style';

const LoginStartPageHeader = (): JSX.Element => {
  const { createLoginPath } = usePaths();
  const intl = useIntl();
  const { xsollaAnalytics } = useConfig();
  const { DOCUMENTATION } = PROJECT_LINKS;

  return (
    <Wrapper>
      <WelcomeBlockWrapper>
        <LoginProductLogotype />
        <WelcomeTitle>{intl.formatMessage({ id: 'welcome-page.header.title' })}</WelcomeTitle>
        <WelcomeDescription>
          {intl.formatMessage({ id: 'welcome-page.header.description' })}
        </WelcomeDescription>
        <StyledLink to={createLoginPath()}>
          <Button
            look="default"
            palette="action"
            size="md"
            data-test-id="welcome_create_login_button"
            onClick={() =>
              xsollaAnalytics.sendClick(
                'login_pa_module__dashboard__create_login',
                'create_login',
                {
                  pageType: 'start_page'
                }
              )
            }>
            <PlusIcon size={20} />
            {intl.formatMessage({ id: 'welcome-page.header.create-login-button' })}
          </Button>
        </StyledLink>
        <AnnotationWrapper>
          {intl.formatMessage(
            { id: 'welcome-page.header.annotation-integration' },
            {
              span: (chunk: string) => (
                <AnnotationSpan>
                  <ClockIcon /> {chunk}
                </AnnotationSpan>
              )
            }
          )}
          <GuideLink href={DOCUMENTATION} target="_blank">
            <Button
              data-test-id="btn-integration-guide"
              look="link"
              palette="brand"
              size="md"
              onClick={() =>
                xsollaAnalytics.sendExternalLink(
                  'login_pa_module__dashboard__guid_link',
                  DOCUMENTATION,
                  {
                    pageType: 'start_page'
                  }
                )
              }>
              <GuideIcon />
              {intl.formatMessage({ id: 'welcome-page.header.guide-link' })}
            </Button>
          </GuideLink>
        </AnnotationWrapper>
      </WelcomeBlockWrapper>

      <DemoLoginWrapper>
        <StartPageLoginDemo />
      </DemoLoginWrapper>
    </Wrapper>
  );
};

export default withRouter(LoginStartPageHeader);
